// The SummitShield seal: shown against anything we have VERIFIED (a domain, a channel,
// a person's confirmed address). One mark, everywhere, so "verified" always looks the
// same — never use a plain green pill for it.

// A scalloped seal: 10 bumps round a circle, drawn once at module load
function sealPath(bumps = 10, outer = 11.8, inner = 9.4, c = 12) {
  const pts = [];
  for (let i = 0; i < bumps * 2; i += 1) {
    const a = (Math.PI * i) / bumps - Math.PI / 2;
    const r = i % 2 === 0 ? outer : inner;
    pts.push([c + r * Math.cos(a), c + r * Math.sin(a)]);
  }
  // Smooth curve through the points: each outer point is a control point
  let d = `M${((pts[pts.length - 1][0] + pts[0][0]) / 2).toFixed(2)},${((pts[pts.length - 1][1] + pts[0][1]) / 2).toFixed(2)}`;
  for (let i = 0; i < pts.length; i += 1) {
    const p = pts[i];
    const n = pts[(i + 1) % pts.length];
    d += ` Q${p[0].toFixed(2)},${p[1].toFixed(2)} ${((p[0] + n[0]) / 2).toFixed(2)},${((p[1] + n[1]) / 2).toFixed(2)}`;
  }
  return `${d} Z`;
}
const SEAL = sealPath();

/** Just the mark. `title` is announced to screen readers (omit when a label sits next to it). */
export function VerifiedSeal({ size = 18, title }) {
  return (
    <svg className="verified-seal" width={size} height={size} viewBox="0 0 24 24" role={title ? 'img' : undefined}
      aria-label={title} aria-hidden={title ? undefined : 'true'} focusable="false">
      {title && <title>{title}</title>}
      <path d={SEAL} className="verified-seal-shape" />
      <circle cx="12" cy="12" r="6.2" className="verified-seal-face" />
      <path d="M9.1 12.2l2 2 3.9-4" className="verified-seal-tick" />
    </svg>
  );
}

/** Seal + label, in place of a status pill wherever something is verified. */
export default function VerifiedBadge({ children = 'Verified', title }) {
  return (
    <span className="verified-badge" title={title}>
      <VerifiedSeal size={18} />
      <span>{children}</span>
    </span>
  );
}
